import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    viewBox="0 0 64 64"
    ref={svgRef}
    {...props}
  >
    <mask
      id="book_svg__a"
      style={{
        maskType: "alpha",
      }}
      width={64}
      height={64}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path fill="currentColor" d="M0 0h64v64H0z" />
    </mask>
    <g mask="url(#book_svg__a)">
      <path
        fill="currentColor"
        d="M32 52.6c-.311 0-.6-.033-.867-.1a1.902 1.902 0 01-.733-.367 26.521 26.521 0 00-6.233-3.033c-2.2-.733-4.478-1.1-6.834-1.1-1.866 0-3.7.244-5.5.733A24.132 24.132 0 006.667 50.8c-.934.489-1.834.467-2.7-.067-.867-.533-1.3-1.31-1.3-2.333V16.267c0-.49.122-.956.366-1.4a2.3 2.3 0 011.1-1 27.823 27.823 0 016.4-2.4c2.223-.534 4.49-.8 6.8-.8 2.578 0 5.1.333 7.567 1a28.743 28.743 0 017.1 3V48.4a27.274 27.274 0 017.133-3.3c2.49-.733 5-1.1 7.534-1.1 1.6 0 3.344.156 5.233.467 1.889.31 3.7.955 5.433 1.933V12.733c.445.178.878.356 1.3.534.423.177.834.377 1.234.6.444.266.8.61 1.066 1.033.267.422.4.878.4 1.367V48.4c0 1.022-.433 1.8-1.3 2.333-.866.534-1.766.556-2.7.067a24.13 24.13 0 00-5.166-2.067 20.892 20.892 0 00-5.5-.733c-2.356 0-4.634.367-6.834 1.1a26.523 26.523 0 00-6.233 3.033c-.222.178-.467.3-.733.367-.267.067-.556.1-.867.1zm5.667-11.867c-.356.267-.723.323-1.1.167-.378-.156-.567-.456-.567-.9V19.067c0-.134.022-.256.067-.367a.887.887 0 01.2-.3L51.6 3.067c.311-.311.678-.39 1.1-.234.422.156.633.456.633.9v22.934a.887.887 0 01-.1.4A1.268 1.268 0 0153 27.4L37.667 40.733z"
      />
    </g>
  </Icon>
));
